import { Pie } from 'vue-chartjs'
import moment from 'moment'

export default {
  extends: Pie,
  props: ['sums'],
  data() {
    const years = Array.from({ length: 8 }, (_, i) => moment().year() - 3 + i);
    const colors = ['#D3D3D3', '#A9A9A9', '#808080', '#359FE6', '#78C9FF', '#8FD2FF', '#99D6FF', '#B9DFF8'];
    const sumKeys = ['prevprevprev', 'prevprev', 'prev', 'current', 'next', 'nextplus', 'nextplusplus', 'nextplusplusplus'];

    return {
      chartdata: {
        labels: years,
        datasets: [{
          label: 'Anzahl Baustellen',
          backgroundColor: colors,
          data: sumKeys.map(key => (this.sums[key] > 0 ? this.sums[key].toFixed(2) : 0)),
          borderWidth: 0
        }]
      },
      options: {
        legend: {
          labels: {
            fontFamily: "Avenir",
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const value = dataset.data[tooltipItem.index];
              return ' ' + parseFloat(value).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
            }
          },
          backgroundColor: '#2c3e50'
        },
      }
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}
